/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
export interface ActionHook {
    errorMsg: string;
    status: Status;
}

export enum Status {
    ERROR = "ERROR",
    FETCHING = "FETCHING",
    INITIAL = "INITIAL",
    DONE = "DONE",
}
